/**
 * Feature Flags API
 *
 * Handles all feature flag-related API calls.
 */

import { BaseApiClient } from '../base';
import { API_ENDPOINTS } from '../endpoints';
import type { FeatureFlagsResponse } from '../types';

export interface UpdateFeatureFlagRequest {
  enabled: boolean;
  metadata?: Record<string, unknown>;
  targetOrgId?: string; // For admin: update flags for specific org
}

export interface UpdateFeatureFlagResponse {
  flag: {
    key: string;
    enabled: boolean;
    metadata: Record<string, unknown> | null;
    updatedAt: string;
  };
  message: string;
}

export interface DeleteFeatureFlagResponse {
  message: string;
  default: boolean;
}

export class FeatureFlagsApi extends BaseApiClient {
  async getFeatureFlags(targetOrgId?: string): Promise<FeatureFlagsResponse> {
    const url = targetOrgId
      ? `${API_ENDPOINTS.FEATURE_FLAGS}?targetOrgId=${targetOrgId}`
      : API_ENDPOINTS.FEATURE_FLAGS;
    return this.request<FeatureFlagsResponse>(url);
  }

  async updateFeatureFlag(
    key: string,
    data: UpdateFeatureFlagRequest
  ): Promise<UpdateFeatureFlagResponse> {
    return this.request<UpdateFeatureFlagResponse>(
      `${API_ENDPOINTS.FEATURE_FLAGS}/${key}`,
      {
        method: 'PUT',
        body: JSON.stringify(data),
      }
    );
  }

  async deleteFeatureFlag(
    key: string,
    targetOrgId?: string
  ): Promise<DeleteFeatureFlagResponse> {
    const url = targetOrgId
      ? `${API_ENDPOINTS.FEATURE_FLAGS}/${key}?targetOrgId=${targetOrgId}`
      : `${API_ENDPOINTS.FEATURE_FLAGS}/${key}`;
    return this.request<DeleteFeatureFlagResponse>(url, {
      method: 'DELETE',
    });
  }
}
